/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromUserIdle from 'app/shared/store/actions/sticky-menu.action';

export interface StickyMenuState {
  topOffset: number;
}

export const initialState = {
  topOffset: 0,
};

export function reducer(state = initialState, action: fromUserIdle.StickyMenuAction): StickyMenuState {
  // tslint:disable-next-line:no-small-switch
  switch (action.type) { // NOSONAR
    case fromUserIdle.SET_TOP_OFFSET: {
      return {
        ...state,
        topOffset: action.payload,
      };
    }
  }
  return state;
}

export const getVideoPlaying = (state: StickyMenuState) => state.topOffset;
